import { ColumnEditorOptions } from "primereact/column";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";
import { useState } from "react";

interface NumberEditorProps {
    options: ColumnEditorOptions;
    unit?: string;
    min?: number;
    max?: number;
}

const toNumber = (value: unknown): number | null => {
    if (typeof value === "number") return value;
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? null : parsed;
    }
    return null;
};

export const NumberEditor = ({ options, unit, min, max }: NumberEditorProps) => {
    // Seed once so the existing number shows on open and survives re-renders.
    const [value, setValue] = useState<number | null>(() => toNumber(options.value));

    const handleChange = (e: InputNumberValueChangeEvent) => {
        setValue(e.value ?? null);
        options.editorCallback?.(e.value);
    };

    return (
        <div className="flex align-items-center gap-2">
            <InputNumber
                value={value}
                onValueChange={handleChange}
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={4}
                min={min}
                max={max}
                autoFocus
            />
            {unit && <span className="text-sm text-color-secondary">{unit}</span>}
        </div>
    );
};

export const numberDisplayTemplate = (value: unknown, unit?: string): string => {
    if (value === null || value === undefined || value === "") return "";

    const numValue = typeof value === "string" ? parseFloat(value) : value;
    if (typeof numValue !== "number" || isNaN(numValue)) return String(value);

    return unit ? `${numValue} ${unit}` : String(numValue);
};
